module.exports = __webpack_public_path__ + "img/team-management.a70e6e0e.svg";